import useMutationWithValidation from "@hooks/useMutationWithValidation";
import useMyExpert from "@hooks/useMyExpert";
import { LinkEventCreateDocument, LinkEventCreateMutation, LinkEventCreateMutationVariables } from "@typing/Generated";
import { sanitizeHtmlHelper } from "@utils/htmlUtils";

type Resource = {
  __typename: string;
  id: string;
};

type SanitizedHtmlHelperArgs = Parameters<typeof sanitizeHtmlHelper>[number];

type Args = Pick<SanitizedHtmlHelperArgs, "journeyId" | "rawHtml"> & {
  handleLinkClick?: SanitizedHtmlHelperArgs["handleLinkClick"];
  resource?: Resource | null;
};

const useSanitizeHtml = ({ handleLinkClick: passedInHandleLinkClick, journeyId, rawHtml, resource }: Args) => {
  const myExpert = useMyExpert();
  const [linkEventCreate] = useMutationWithValidation<LinkEventCreateMutation, LinkEventCreateMutationVariables>(
    LinkEventCreateDocument,
    "linkEvent"
  );
  const handleLinkClick = (link: string, internal: boolean) => {
    linkEventCreate({
      journeyId,
      link,
      resourceId: resource?.id,
      resourceType: resource?.__typename
    });
    if (passedInHandleLinkClick) passedInHandleLinkClick(link, internal);
  };

  return sanitizeHtmlHelper({ handleLinkClick, journeyId, myExpert, rawHtml });
};

export default useSanitizeHtml;
